import type { FC } from 'react';

import { CalendarBody } from './calendar-body';
import { CalendarControlButton } from './calendar-control-button';
import { CalendarControls } from './calendar-controls';
import { CalendarDay } from './calendar-day';
import { CalendarDayOfWeek } from './calendar-day-of-week';
import { CalendarMonth } from './calendar-month';
import { CalendarRoot } from './calendar-root';
import { CalendarYearSelect } from './calendar-year-select';
import type { CalendarPropsInterface } from './types/calendar.types';

/**
 * @since 10.0.0
 */

export const Calendar: FC<CalendarPropsInterface> & {
  Root: typeof CalendarRoot;
  Body: typeof CalendarBody;
  Controls: typeof CalendarControls;
  Day: typeof CalendarDay;
  DayOfWeek: typeof CalendarDayOfWeek;
  ControlButton: typeof CalendarControlButton;
  YearSelect: typeof CalendarYearSelect;
  Month: typeof CalendarMonth;
} = (props: CalendarPropsInterface) => {
  const {
    renderDay,
    renderDayOfWeek,
    renderPrevMonth,
    renderNextMonth,
    renderYearSelect,
    renderMonth,
    ...rest
  } = props;

  return (
    <Calendar.Root {...rest}>
      <Calendar.Controls
        renderPrevMonth={renderPrevMonth}
        renderNextMonth={renderNextMonth}
        renderYearSelect={renderYearSelect}
        renderMonth={renderMonth}
      />
      <Calendar.Body renderDayOfWeek={renderDayOfWeek} renderDay={renderDay} />
    </Calendar.Root>
  );
};

Calendar.displayName = 'Calendar';

Calendar.Root = CalendarRoot;
Calendar.Body = CalendarBody;
Calendar.Controls = CalendarControls;
Calendar.Day = CalendarDay;
Calendar.DayOfWeek = CalendarDayOfWeek;
Calendar.ControlButton = CalendarControlButton;
Calendar.YearSelect = CalendarYearSelect;
Calendar.Month = CalendarMonth;
